var map = {
	"./banners/gwt-pricing-banner-bg.jpg": 1700,
	"./banners/gwt-pricing-banner-lms-bg.jpg": 1701,
	"./banners/gwt-pricing-banner-lms-mobile-bg.jpg": 1702,
	"./banners/gwt-pricing-banner-mobile-bg.jpg": 1703,
	"./banners/gwt-promo-banner-bg.jpg": 1704,
	"./banners/gwt-promo-banner-mobile-bg.jpg": 1705,
	"./banners/icon-heart.png": 1706,
	"./banners/icon-tick.png": 1707,
	"./banners/jumpstart-2023-pricing-banner-mobile.jpg": 1708,
	"./banners/jumpstart-2023-pricing-banner.jpg": 1709,
	"./banners/jumpstart-site-banner-bg-mobile.jpg": 1710,
	"./banners/jumpstart-site-banner-bg.jpg": 1711,
	"./banners/oth-pricing-banner-bg.jpg": 1712,
	"./banners/oth-pricing-banner-mobile-bg.jpg": 1713,
	"./banners/oth-promo-banner-bg.jpg": 1714,
	"./banners/oth-promo-banner-mobile-bg.jpg": 1715,
	"./banners/oth-trigger-banner-bg.jpg": 1716,
	"./banners/oth-trigger-banner-mobile-bg.jpg": 1717,
	"./banners/technologies-bg-mobile-pricing.png": 1668,
	"./banners/technologies-bg-mobile.png": 1669,
	"./banners/technologies-bg-pricing.png": 1670,
	"./banners/technologies-bg.png": 1671,
	"./banners/tft-pricing-banner-bg.webp": 1718,
	"./banners/tft-pricing-banner-laptop-bg.webp": 1719,
	"./banners/tft-pricing-banner-mobile-bg.webp": 1720,
	"./banners/tft-site-banner-bg-laptop-last-promo.webp": 1721,
	"./banners/tft-site-banner-bg-laptop.webp": 1722,
	"./banners/tft-site-banner-bg-last-promo.webp": 1723,
	"./banners/tft-site-banner-bg-mobile.webp": 1724,
	"./banners/tft-site-banner-bg.webp": 1725,
	"./banners/tft-trigger-banner-bg.webp": 1726,
	"./banners/tft-trigger-banner-laptop-bg.webp": 1727,
	"./banners/tft-trigger-banner-mobile-bg.webp": 1728,
	"./banners/trigger-offer-bg-mobile.jpg": 1729,
	"./banners/trigger-offer-bg.jpg": 1730,
	"./black-friday-promo-banner.png": 1799,
	"./blog-authors.jpg": 1800,
	"./campaign-black-friday-2023/ds-bf-bg-banner-mobile.webp": 1801,
	"./campaign-black-friday-2023/ds-bf-bg-banner.webp": 1802,
	"./campaign-black-friday-2023/ds-bf-bg-billing-mobile.webp": 1803,
	"./campaign-black-friday-2023/ds-bf-bg-billing.webp": 1804,
	"./campaign-black-friday-2023/ds-bf-bg-pricing-mobile.webp": 1805,
	"./campaign-black-friday-2023/ds-bf-bg-pricing.webp": 1806,
	"./campaign-black-friday-2023/ds-bf-title-hero-mobile.webp": 1672,
	"./campaign-black-friday-2023/ds-bf-title-hero.webp": 1673,
	"./campaign-black-friday-2023/fa-bf-bg-banner-mobile.webp": 1807,
	"./campaign-black-friday-2023/fa-bf-bg-banner.webp": 1808,
	"./campaign-black-friday-2023/fa-bf-bg-billing-mobile.webp": 1809,
	"./campaign-black-friday-2023/fa-bf-bg-billing.webp": 1810,
	"./campaign-black-friday-2023/fa-bf-bg-pricing-mobile.webp": 1811,
	"./campaign-black-friday-2023/fa-bf-bg-pricing.webp": 1812,
	"./campaign-black-friday-2023/fa-bf-title-hero-mobile.webp": 1674,
	"./campaign-black-friday-2023/fa-bf-title-hero.webp": 1675,
	"./campaign-chat-gpt/campaign-chat-gpt-bg-blog.webp": 1813,
	"./campaign-chat-gpt/campaign-chat-gpt-bg-mobile.webp": 1814,
	"./campaign-chat-gpt/campaign-chat-gpt-bg.webp": 1815,
	"./campaign-cyber-monday-2023/cm-ext-label-mobile.webp": 1676,
	"./campaign-cyber-monday-2023/cm-ext-label.webp": 1677,
	"./campaign-cyber-monday-2023/ds-cm-bg-banner-mobile.webp": 1816,
	"./campaign-cyber-monday-2023/ds-cm-bg-banner.webp": 1817,
	"./campaign-cyber-monday-2023/ds-cm-bg-billing-mobile.webp": 1818,
	"./campaign-cyber-monday-2023/ds-cm-bg-billing.webp": 1819,
	"./campaign-cyber-monday-2023/ds-cm-bg-pricing-lms-mobile.webp": 1820,
	"./campaign-cyber-monday-2023/ds-cm-bg-pricing-lms.webp": 1821,
	"./campaign-cyber-monday-2023/ds-cm-bg-pricing-site-mobile.webp": 1822,
	"./campaign-cyber-monday-2023/ds-cm-bg-pricing-site.webp": 1823,
	"./campaign-cyber-monday-2023/ds-cm-title-hero-mobile.webp": 1678,
	"./campaign-cyber-monday-2023/ds-cm-title-hero2.webp": 1679,
	"./campaign-cyber-monday-2023/fa-cm-bg-banner-mobile.webp": 1824,
	"./campaign-cyber-monday-2023/fa-cm-bg-banner.webp": 1825,
	"./campaign-cyber-monday-2023/fa-cm-bg-billing-mobile.webp": 1826,
	"./campaign-cyber-monday-2023/fa-cm-bg-billing.webp": 1827,
	"./campaign-cyber-monday-2023/fa-cm-bg-pricing-lms-mobile.webp": 1828,
	"./campaign-cyber-monday-2023/fa-cm-bg-pricing-lms.webp": 1829,
	"./campaign-cyber-monday-2023/fa-cm-bg-pricing-site-mobile.webp": 1830,
	"./campaign-cyber-monday-2023/fa-cm-bg-pricing-site.webp": 1831,
	"./campaign-cyber-monday-2023/fa-cm-title-hero-mobile.webp": 1680,
	"./campaign-cyber-monday-2023/fa-cm-title-hero2.webp": 1681,
	"./campaign-free-weeks-2023/ds-fw-bg-banner-mobile.webp": 1832,
	"./campaign-free-weeks-2023/ds-fw-bg-banner.webp": 1833,
	"./campaign-free-weeks-2023/ds-fw-bg-billing-mobile.webp": 1834,
	"./campaign-free-weeks-2023/ds-fw-bg-billing.webp": 1835,
	"./campaign-free-weeks-2023/ds-fw-bg-pricing-mobile.webp": 1836,
	"./campaign-free-weeks-2023/ds-fw-bg-pricing.webp": 1837,
	"./campaign-free-weeks-2023/fa-fw-bg-banner-mobile.webp": 1838,
	"./campaign-free-weeks-2023/fa-fw-bg-banner.webp": 1839,
	"./campaign-free-weeks-2023/fa-fw-bg-billing-mobile.webp": 1840,
	"./campaign-free-weeks-2023/fa-fw-bg-billing.webp": 1841,
	"./campaign-free-weeks-2023/fa-fw-bg-pricing-mobile.webp": 1842,
	"./campaign-free-weeks-2023/fa-fw-bg-pricing.webp": 1843,
	"./campaign-future-proof/future-proof-bg-banner-mobile.webp": 1844,
	"./campaign-future-proof/future-proof-bg-banner.webp": 1845,
	"./campaign-future-proof/future-proof-bg-billing-mobile.webp": 1846,
	"./campaign-future-proof/future-proof-bg-billing.webp": 1847,
	"./campaign-future-proof/future-proof-bg-pricing-mobile.webp": 1848,
	"./campaign-future-proof/future-proof-bg-pricing.webp": 1849,
	"./campaign-future-proof/learn-future-proof.webp": 516,
	"./campaign-get-future-ready/dsgfr-bg-banner-mobile.webp": 1850,
	"./campaign-get-future-ready/dsgfr-bg-banner.webp": 1851,
	"./campaign-get-future-ready/dsgfr-bg-billing-mobile.webp": 1852,
	"./campaign-get-future-ready/dsgfr-bg-billing.webp": 1853,
	"./campaign-get-future-ready/dsgfr-bg-blog.webp": 1854,
	"./campaign-get-future-ready/dsgfr-bg-pricing-mobile.webp": 1855,
	"./campaign-get-future-ready/dsgfr-bg-pricing.webp": 1856,
	"./campaign-get-future-ready/gfr-bg-banner-mobile.webp": 1857,
	"./campaign-get-future-ready/gfr-bg-banner.webp": 1858,
	"./campaign-get-future-ready/gfr-bg-billing-mobile.webp": 1859,
	"./campaign-get-future-ready/gfr-bg-billing.webp": 1860,
	"./campaign-get-future-ready/gfr-bg-blog.webp": 1861,
	"./campaign-get-future-ready/gfr-bg-pricing-mobile.webp": 1862,
	"./campaign-get-future-ready/gfr-bg-pricing.webp": 1863,
	"./campaign-transform-your-future-2024/ds-tyf-bg-banner-mobile.webp": 1864,
	"./campaign-transform-your-future-2024/ds-tyf-bg-banner.webp": 1865,
	"./campaign-transform-your-future-2024/ds-tyf-bg-billing-mobile.webp": 1866,
	"./campaign-transform-your-future-2024/ds-tyf-bg-billing.webp": 1867,
	"./campaign-transform-your-future-2024/ds-tyf-bg-pricing-lms-mobile.webp": 1868,
	"./campaign-transform-your-future-2024/ds-tyf-bg-pricing-lms.webp": 1869,
	"./campaign-transform-your-future-2024/ds-tyf-bg-pricing-site-mobile.webp": 1870,
	"./campaign-transform-your-future-2024/ds-tyf-bg-pricing-site.webp": 1871,
	"./campaign-transform-your-future-2024/fa-tyf-bg-banner-mobile.webp": 1872,
	"./campaign-transform-your-future-2024/fa-tyf-bg-banner.webp": 1873,
	"./campaign-transform-your-future-2024/fa-tyf-bg-billing-mobile.webp": 1874,
	"./campaign-transform-your-future-2024/fa-tyf-bg-billing.webp": 1875,
	"./campaign-transform-your-future-2024/fa-tyf-bg-pricing-lms-mobile.webp": 1876,
	"./campaign-transform-your-future-2024/fa-tyf-bg-pricing-lms.webp": 1877,
	"./campaign-transform-your-future-2024/fa-tyf-bg-pricing-site-mobile.webp": 1878,
	"./campaign-transform-your-future-2024/fa-tyf-bg-pricing-site.webp": 1879,
	"./campaigns/ds-fa2024-bg-banner-mobile.webp": 1178,
	"./campaigns/ds-fa2024-bg-banner.webp": 1179,
	"./campaigns/ds-fp2024-banner-block-laptop.webp": 646,
	"./campaigns/ds-fp2024-banner-block.webp": 1180,
	"./campaigns/ds-fp2024-banner-side-laptop.webp": 647,
	"./campaigns/ds-fp2024-banner-side-mobile.webp": 539,
	"./campaigns/ds-fp2024-banner-side.webp": 1181,
	"./campaigns/ds-fp2024-bg-banner-mobile.webp": 1182,
	"./campaigns/ds-fp2024-bg-banner.webp": 1183,
	"./campaigns/ds-fp2024-bg-billing-mobile.webp": 1184,
	"./campaigns/ds-fp2024-bg-billing.webp": 1185,
	"./campaigns/ds-fp2024-bg-pricing-mobile.webp": 1186,
	"./campaigns/ds-fp2024-bg-pricing.webp": 1187,
	"./campaigns/ds-lda-banner-block-laptop.webp": 648,
	"./campaigns/ds-lda-banner-block.webp": 1188,
	"./campaigns/ds-lda-banner-extend-block-laptop.webp": 649,
	"./campaigns/ds-lda-banner-extend-block.webp": 1189,
	"./campaigns/ds-lda-banner-extend-side-laptop.webp": 650,
	"./campaigns/ds-lda-banner-extend-side-mobile.webp": 651,
	"./campaigns/ds-lda-banner-extend-side.webp": 1190,
	"./campaigns/ds-lda-banner-side-laptop.webp": 652,
	"./campaigns/ds-lda-banner-side-mobile.webp": 653,
	"./campaigns/ds-lda-banner-side.webp": 1191,
	"./campaigns/ds-lda-bg-banner-mobile.webp": 1192,
	"./campaigns/ds-lda-bg-banner.webp": 1193,
	"./campaigns/ds-lda-bg-billing-extend-mobile.webp": 1194,
	"./campaigns/ds-lda-bg-billing-mobile.webp": 1195,
	"./campaigns/ds-lda-bg-billing.webp": 1196,
	"./campaigns/ds-lda-bg-pricing-mobile.webp": 1197,
	"./campaigns/ds-lda-bg-pricing.webp": 1198,
	"./campaigns/ds-mw-banner-block-laptop.webp": 654,
	"./campaigns/ds-mw-banner-block.webp": 1199,
	"./campaigns/ds-mw-banner-side-laptop.webp": 655,
	"./campaigns/ds-mw-banner-side-mobile.webp": 656,
	"./campaigns/ds-mw-banner-side.webp": 1200,
	"./campaigns/ds-mw-bg-banner-mobile.webp": 1201,
	"./campaigns/ds-mw-bg-banner.webp": 1202,
	"./campaigns/ds-mw-bg-billing-mobile.webp": 1203,
	"./campaigns/ds-mw-bg-billing.webp": 1204,
	"./campaigns/ds-mw-bg-pricing-lms-mobile.webp": 1205,
	"./campaigns/ds-mw-bg-pricing-lms.webp": 1206,
	"./campaigns/ds-mw-bg-pricing-site-mobile.webp": 1207,
	"./campaigns/ds-mw-bg-pricing-site.webp": 1208,
	"./campaigns/ds-mw-extend-wide.webp": 1152,
	"./campaigns/ds-mw-extend.webp": 657,
	"./campaigns/ds-mw-hero-stamp.webp": 1153,
	"./campaigns/ds-mw-title-center.webp": 1154,
	"./campaigns/ds-mw-title-left.webp": 744,
	"./campaigns/ds-mw-title.webp": 658,
	"./campaigns/ds-mwe-banner-block-laptop.webp": 659,
	"./campaigns/ds-mwe-banner-block.webp": 1209,
	"./campaigns/ds-mwe-banner-side-laptop.webp": 660,
	"./campaigns/ds-mwe-banner-side-mobile.webp": 661,
	"./campaigns/ds-mwe-banner-side.webp": 1210,
	"./campaigns/ds-oth-bg-banner-block.webp": 1211,
	"./campaigns/ds-oth-bg-banner-mobile.webp": 1212,
	"./campaigns/ds-oth-bg-banner-side.webp": 1213,
	"./campaigns/ds-oth-bg-banner.webp": 1214,
	"./campaigns/ds-oth-bg-billing-mobile.webp": 1215,
	"./campaigns/ds-oth-bg-billing.webp": 1216,
	"./campaigns/ds-oth-bg-pricing-mobile.webp": 1217,
	"./campaigns/ds-oth-bg-pricing.webp": 1218,
	"./campaigns/fa-fa2024-bg-banner-mobile.webp": 1219,
	"./campaigns/fa-fa2024-bg-banner.webp": 1220,
	"./campaigns/fa-ft2024-banner-block-laptop.webp": 662,
	"./campaigns/fa-ft2024-banner-block.webp": 1221,
	"./campaigns/fa-ft2024-banner-side-laptop.webp": 663,
	"./campaigns/fa-ft2024-banner-side-mobile.webp": 540,
	"./campaigns/fa-ft2024-banner-side.webp": 1222,
	"./campaigns/fa-ft2024-bg-billing-mobile.webp": 1223,
	"./campaigns/fa-ft2024-bg-billing.webp": 1224,
	"./campaigns/fa-ft2024-bg-pricing-mobile.webp": 1225,
	"./campaigns/fa-ft2024-bg-pricing.webp": 1226,
	"./campaigns/fa-lf-banner-block-laptop.webp": 664,
	"./campaigns/fa-lf-banner-block.webp": 1227,
	"./campaigns/fa-lf-banner-extend-block-laptop.webp": 665,
	"./campaigns/fa-lf-banner-extend-block.webp": 1228,
	"./campaigns/fa-lf-banner-extend-side-laptop.webp": 666,
	"./campaigns/fa-lf-banner-extend-side-mobile.webp": 667,
	"./campaigns/fa-lf-banner-extend-side.webp": 1229,
	"./campaigns/fa-lf-banner-side-laptop.webp": 668,
	"./campaigns/fa-lf-banner-side-mobile.webp": 669,
	"./campaigns/fa-lf-banner-side.webp": 1230,
	"./campaigns/fa-lf-bg-banner-mobile.webp": 1231,
	"./campaigns/fa-lf-bg-banner.webp": 1232,
	"./campaigns/fa-lf-bg-billing-extend-mobile.webp": 1233,
	"./campaigns/fa-lf-bg-billing-mobile.webp": 1234,
	"./campaigns/fa-lf-bg-billing.webp": 1235,
	"./campaigns/fa-lf-bg-pricing-mobile.webp": 1236,
	"./campaigns/fa-lf-bg-pricing.webp": 1237,
	"./campaigns/fa-mw-banner-block-laptop.webp": 670,
	"./campaigns/fa-mw-banner-block.webp": 1238,
	"./campaigns/fa-mw-banner-side-laptop.webp": 671,
	"./campaigns/fa-mw-banner-side-mobile.webp": 672,
	"./campaigns/fa-mw-banner-side.webp": 1239,
	"./campaigns/fa-mw-bg-banner-mobile.webp": 1240,
	"./campaigns/fa-mw-bg-banner.webp": 1241,
	"./campaigns/fa-mw-bg-billing-mobile.webp": 1242,
	"./campaigns/fa-mw-bg-billing.webp": 1243,
	"./campaigns/fa-mw-bg-pricing-lms-mobile.webp": 1244,
	"./campaigns/fa-mw-bg-pricing-lms.webp": 1245,
	"./campaigns/fa-mw-bg-pricing-site-mobile.webp": 1246,
	"./campaigns/fa-mw-bg-pricing-site.webp": 1247,
	"./campaigns/fa-mw-extend-wide.webp": 1155,
	"./campaigns/fa-mw-extend.webp": 673,
	"./campaigns/fa-mw-title.webp": 674,
	"./campaigns/fa-mwe-banner-block-laptop.webp": 675,
	"./campaigns/fa-mwe-banner-block.webp": 1248,
	"./campaigns/fa-mwe-banner-side-laptop.webp": 676,
	"./campaigns/fa-mwe-banner-side-mobile.webp": 677,
	"./campaigns/fa-mwe-banner-side.webp": 1249,
	"./campaigns/fa-oth-bg-banner-mobile.webp": 1250,
	"./campaigns/fa-oth-bg-banner-side.webp": 1251,
	"./campaigns/fa-oth-bg-banner.webp": 1252,
	"./campaigns/fa-oth-bg-billing-mobile.webp": 1253,
	"./campaigns/fa-oth-bg-billing.webp": 1254,
	"./campaigns/fa-oth-bg-pricing-lms-mobile.webp": 1255,
	"./campaigns/fa-oth-bg-pricing-lms.webp": 1256,
	"./campaigns/fa-oth-bg-pricing-mobile.webp": 1257,
	"./campaigns/fa-oth-bg-pricing.webp": 1258,
	"./campaigns/video-thumbs/vthumb-ahmed.webp": 499,
	"./campaigns/video-thumbs/vthumb-ernest.webp": 500,
	"./campaigns/video-thumbs/vthumb-julián.webp": 501,
	"./campaigns/video-thumbs/vthumb-lee.webp": 502,
	"./campaigns/video-thumbs/vthumb-meghan.webp": 503,
	"./campaigns/video-thumbs/vthumb-mihaela.webp": 504,
	"./campaigns/video-thumbs/vthumb-nada.webp": 505,
	"./career-certificate.jpg": 1880,
	"./career-track-1-dashboard.png": 1635,
	"./career-track-1-wide.png": 1636,
	"./career-track-1.png": 1637,
	"./career-track-2-dashboard.png": 1638,
	"./career-track-2-wide.png": 1639,
	"./career-track-2.png": 1640,
	"./career-track-3-dashboard.png": 1641,
	"./career-track-3-wide.png": 1642,
	"./career-track-3.png": 1643,
	"./career-track-4-wide.jpg": 1881,
	"./career-track-4.png": 1644,
	"./career-track-5-wide.jpg": 1882,
	"./career-track-6-wide.jpg": 1883,
	"./career-track-bg.jpg": 1884,
	"./career-track-video-placeholder.png": 1645,
	"./certificate-open-graph.png": 1885,
	"./check.png": 1886,
	"./course-bg.jpg": 1887,
	"./course-certificate-lms.jpg": 1888,
	"./course-certificate.jpg": 1889,
	"./course-elective-placeholder.png": 1731,
	"./course-project.png": 1890,
	"./cyber-monday-promo-banner-mobile.png": 1891,
	"./cyber-monday-promo-banner.png": 1892,
	"./discover_data-science-booklet-mobile.jpg": 1893,
	"./discover_data-science-booklet.jpg": 1894,
	"./discover_data-science-career-guide-mobile.jpg": 1895,
	"./discover_data-science-career-guide-yt-mobile.jpg": 1896,
	"./discover_data-science-career-guide-yt.jpg": 1897,
	"./discover_data-science-career-guide.jpg": 1898,
	"./discover_data-science-interview-questions-guide-mobile.jpg": 1899,
	"./discover_data-science-interview-questions-guide-yt-mobile.jpg": 1900,
	"./discover_data-science-interview-questions-guide-yt.jpg": 1901,
	"./discover_data-science-interview-questions-guide.jpg": 1902,
	"./discover_data-science-sql-basics-mobile.jpg": 1903,
	"./discover_data-science-sql-basics.jpg": 1904,
	"./discover_data-science-statistics-cheatsheet-mobile.jpg": 1905,
	"./discover_data-science-statistics-cheatsheet.jpg": 1906,
	"./discover_newsletter-mobile.jpg": 1907,
	"./discover_newsletter.jpg": 1908,
	"./discover_offer-expired-mobile.jpg": 1909,
	"./discover_offer-expired.jpg": 1910,
	"./discover_ty.jpg": 1911,
	"./emoji-neutral-face.png": 1912,
	"./emoji-partying-face.png": 1913,
	"./emojis/angry-red.png": 678,
	"./emojis/angry.png": 679,
	"./emojis/anguished.png": 680,
	"./emojis/anxious.png": 681,
	"./emojis/beaming-face.png": 682,
	"./emojis/confounded-normal.png": 683,
	"./emojis/confounded.png": 684,
	"./emojis/confused.png": 685,
	"./emojis/crying-loudly.png": 686,
	"./emojis/crying.png": 687,
	"./emojis/devil.png": 688,
	"./emojis/disappointed.png": 689,
	"./emojis/distraught.png": 690,
	"./emojis/dizzy.png": 691,
	"./emojis/downcast.png": 692,
	"./emojis/expressionless.png": 693,
	"./emojis/fearful.png": 694,
	"./emojis/frowning-eyebrows.png": 695,
	"./emojis/frowning.png": 696,
	"./emojis/grimacing.png": 697,
	"./emojis/grinning-smiling-eyes.png": 698,
	"./emojis/grinning-smiling-squinting-eyes.png": 699,
	"./emojis/grinning.png": 700,
	"./emojis/hand-1.png": 701,
	"./emojis/hand-2.png": 702,
	"./emojis/hand-3.png": 703,
	"./emojis/hand-4.png": 704,
	"./emojis/hand-5.png": 705,
	"./emojis/inlove.png": 706,
	"./emojis/innocent.png": 707,
	"./emojis/kissing-closed-eyes.png": 708,
	"./emojis/kissing.png": 709,
	"./emojis/laughing.png": 710,
	"./emojis/mask.png": 711,
	"./emojis/neutral.png": 712,
	"./emojis/persevering.png": 713,
	"./emojis/relieved.png": 714,
	"./emojis/sad.png": 715,
	"./emojis/screaming.png": 716,
	"./emojis/shy.png": 717,
	"./emojis/sleepy.png": 718,
	"./emojis/smile-licky.png": 719,
	"./emojis/smile.png": 720,
	"./emojis/smirk.png": 721,
	"./emojis/smoked.png": 722,
	"./emojis/steamy.png": 723,
	"./emojis/stick-out-tongue.png": 724,
	"./emojis/sunglasses.png": 725,
	"./emojis/surprised.png": 726,
	"./emojis/tongue-out.png": 727,
	"./emojis/unamused.png": 728,
	"./emojis/weary.png": 729,
	"./emojis/wink-licky.png": 730,
	"./emojis/wink.png": 731,
	"./emojis/without-mouth.png": 732,
	"./exams-and-certification-ds.webp": 1732,
	"./exams-and-certification-fa.webp": 1733,
	"./exams/archive.png": 1259,
	"./exams/excel.png": 1260,
	"./exams/html.png": 1261,
	"./exams/image.png": 1262,
	"./exams/json.png": 1263,
	"./exams/pdf.png": 1264,
	"./exams/powerbi.png": 1265,
	"./exams/powerpoint.png": 1266,
	"./exams/python.png": 1267,
	"./exams/r.png": 1268,
	"./exams/sql.png": 1269,
	"./exams/tableau.png": 1270,
	"./exams/text.png": 1271,
	"./exams/unknown.png": 1272,
	"./exams/word.png": 1273,
	"./exercises-reactions/burst-down.gif": 1274,
	"./exercises-reactions/burst-left.gif": 745,
	"./exercises-reactions/correct/cool-sunglasses-gif.gif": 1914,
	"./exercises-reactions/correct/exploding-head-gif.gif": 1915,
	"./exercises-reactions/correct/higher-quality/cool-sunglasses-gif-2.gif": 1275,
	"./exercises-reactions/correct/higher-quality/exploding-head-gif-2.gif": 1276,
	"./exercises-reactions/correct/higher-quality/nerd-face-gif-2.gif": 746,
	"./exercises-reactions/correct/higher-quality/partying-face-gif-2.gif": 747,
	"./exercises-reactions/correct/higher-quality/star-struck-gif-2.gif": 1277,
	"./exercises-reactions/correct/higher-quality/straight-fire-gif-2.gif": 1278,
	"./exercises-reactions/correct/higher-quality/thumbs-up-gif-2.gif": 1279,
	"./exercises-reactions/correct/nerd-face-gif.gif": 1916,
	"./exercises-reactions/correct/partying-face-gif.gif": 1917,
	"./exercises-reactions/correct/star-struck-gif.gif": 1918,
	"./exercises-reactions/correct/straight-fire-gif.gif": 1919,
	"./exercises-reactions/correct/thumbs-up-gif.gif": 1920,
	"./exercises-reactions/incorrect/confusion-gif.gif": 1921,
	"./exercises-reactions/incorrect/flushed-face-gif.gif": 1922,
	"./exercises-reactions/incorrect/higher-quality/confusion-gif-2.gif": 1156,
	"./exercises-reactions/incorrect/higher-quality/flushed-face-gif-2.gif": 1157,
	"./exercises-reactions/incorrect/higher-quality/maybe-not-gif-2.gif": 1158,
	"./exercises-reactions/incorrect/higher-quality/neutral-face-gif-2.gif": 733,
	"./exercises-reactions/incorrect/higher-quality/thinking-face-gif-2.gif": 599,
	"./exercises-reactions/incorrect/maybe-not-gif.gif": 1923,
	"./exercises-reactions/incorrect/neutral-face-gif.gif": 1924,
	"./exercises-reactions/incorrect/thinking-face-gif.gif": 1925,
	"./exercises/categorize.webp": 1280,
	"./exercises/fill-blank-selection.webp": 1281,
	"./exercises/fill-blank-typing.webp": 1282,
	"./exercises/flashcards.webp": 1283,
	"./exercises/multiple-choice.webp": 1284,
	"./exercises/order.webp": 1285,
	"./exercises/single-choice.webp": 1286,
	"./exercises/true-false.webp": 1287,
	"./expert-insight-placeholder.webp": 1926,
	"./fa/course-certificate-lms.jpg": 815,
	"./fa/discover_ty.jpg": 816,
	"./fa/fa-career-certificate.jpg": 817,
	"./fa/fa-career-track-4.jpg": 594,
	"./fa/fa-career-track-5.jpg": 595,
	"./fa/fa-career-track-6.jpg": 596,
	"./fa/fa-career-track-bg-mobile.jpg": 597,
	"./fa/fa-career-track-bg.jpg": 598,
	"./fa/fa-course-background.png": 818,
	"./fa/fa-course-certificate-lms.jpg": 819,
	"./fa/fa-course-certificate.jpg": 820,
	"./fa/fa-course-elective-placeholder.png": 743,
	"./fa/fa-course-exams-lms.jpg": 821,
	"./fa/fa-discover_offer-expired-mobile.jpg": 822,
	"./fa/fa-discover_offer-expired.jpg": 823,
	"./fa/fa-discover_ty-mobile.jpg": 824,
	"./fa/fa-discover_ty.jpg": 825,
	"./fa/fa-get-a-physical-copy-of-your-certificate-lms.jpg": 826,
	"./fa/fa-get-a-physical-copy-of-your-certificate.jpg": 827,
	"./fa/fa-maintenance.png": 645,
	"./fa/fa-mobile-course-certificate.jpg": 828,
	"./fa/fa-practice-exams-lms.jpg": 829,
	"./fa/fa-qa.jpg": 830,
	"./fa/fa-refer-a-friend.jpg": 831,
	"./fa/fa-thank-you-bg-mobile.jpg": 832,
	"./fa/fa-thank-you-bg.jpg": 833,
	"./fa/fa-track-exams-lms.jpg": 834,
	"./fa/fa-verify-certificate-desktop.jpg": 835,
	"./fa/fa-verify-certificate-mobile.jpg": 836,
	"./fa/get-a-physical-copy-of-your-certificate-lms.jpg": 837,
	"./files/icon-archive.png": 1288,
	"./files/icon-excel.png": 1289,
	"./files/icon-html.png": 1290,
	"./files/icon-image.png": 1291,
	"./files/icon-json.png": 1292,
	"./files/icon-pdf.png": 1293,
	"./files/icon-power-bi.png": 1294,
	"./files/icon-power-point.png": 1295,
	"./files/icon-python-file.png": 1296,
	"./files/icon-r-programming.png": 1297,
	"./files/icon-sql.png": 1298,
	"./files/icon-tableau.png": 1299,
	"./files/icon-text.png": 1300,
	"./files/icon-word.png": 1301,
	"./finance-courses-offer-banner-mobile.jpg": 1927,
	"./get-a-physical-copy-of-your-certificate-lms.jpg": 1928,
	"./get-a-physical-copy-of-your-certificate.jpg": 1929,
	"./hero-ken.jpg": 1930,
	"./hero-talent-pool.jpg": 1931,
	"./hero-tina.jpg": 1932,
	"./icon-assignment.png": 1933,
	"./icon-money-back-dark.png": 533,
	"./icon-money-back-light.png": 534,
	"./icon-money-back.png": 535,
	"./icon-practice-exam.png": 1682,
	"./icon-price-lock-dark.png": 536,
	"./icon-price-lock-light.png": 537,
	"./icon-price-lock.png": 538,
	"./icon-pro-plan-overlay.png": 1734,
	"./icon-projects.png": 1735,
	"./icon-quiz.png": 1934,
	"./instructors.jpg": 1935,
	"./live-training-mobile-new.png": 1761,
	"./live-training-mobile.png": 1936,
	"./live-training-new.png": 1762,
	"./live-training.png": 1937,
	"./maintenance.png": 1736,
	"./mobile-navigation.png": 1938,
	"./practice-exams-lms.jpg": 1939,
	"./pricing-black-friday-campaign-banner.png": 1940,
	"./pricing-cyber-monday-banner-mobile.png": 1941,
	"./pricing-cyber-monday-banner.jpg": 1942,
	"./program-certificate.jpg": 1943,
	"./qa.jpg": 1944,
	"./refer-a-friend.jpg": 1945,
	"./refer-friens.png": 1946,
	"./section-backgrounds/section-bg-1-small.webp": 1302,
	"./section-backgrounds/section-bg-1.webp": 1303,
	"./section-backgrounds/section-bg-10-small.webp": 1304,
	"./section-backgrounds/section-bg-10.webp": 1305,
	"./section-backgrounds/section-bg-11-small.webp": 1306,
	"./section-backgrounds/section-bg-11.webp": 1307,
	"./section-backgrounds/section-bg-12-small.webp": 1308,
	"./section-backgrounds/section-bg-12.webp": 1309,
	"./section-backgrounds/section-bg-13-small.webp": 1310,
	"./section-backgrounds/section-bg-13.webp": 1311,
	"./section-backgrounds/section-bg-14-small.webp": 1312,
	"./section-backgrounds/section-bg-14.webp": 1313,
	"./section-backgrounds/section-bg-15-small.webp": 1314,
	"./section-backgrounds/section-bg-15.webp": 1315,
	"./section-backgrounds/section-bg-16-small.webp": 1316,
	"./section-backgrounds/section-bg-16.webp": 1317,
	"./section-backgrounds/section-bg-17-small.webp": 1318,
	"./section-backgrounds/section-bg-17.webp": 1319,
	"./section-backgrounds/section-bg-18-small.webp": 1320,
	"./section-backgrounds/section-bg-18.webp": 1321,
	"./section-backgrounds/section-bg-19-small.webp": 1322,
	"./section-backgrounds/section-bg-19.webp": 1323,
	"./section-backgrounds/section-bg-2-small.webp": 1324,
	"./section-backgrounds/section-bg-2.webp": 1325,
	"./section-backgrounds/section-bg-20-small.webp": 1326,
	"./section-backgrounds/section-bg-20.webp": 1327,
	"./section-backgrounds/section-bg-21-small.webp": 1328,
	"./section-backgrounds/section-bg-21.webp": 1329,
	"./section-backgrounds/section-bg-22-small.webp": 1330,
	"./section-backgrounds/section-bg-22.webp": 1331,
	"./section-backgrounds/section-bg-23-small.webp": 1332,
	"./section-backgrounds/section-bg-23.webp": 1333,
	"./section-backgrounds/section-bg-24-small.webp": 1334,
	"./section-backgrounds/section-bg-24.webp": 1335,
	"./section-backgrounds/section-bg-25-small.webp": 1336,
	"./section-backgrounds/section-bg-25.webp": 1337,
	"./section-backgrounds/section-bg-26-small.webp": 1338,
	"./section-backgrounds/section-bg-26.webp": 1339,
	"./section-backgrounds/section-bg-27-small.webp": 1340,
	"./section-backgrounds/section-bg-27.webp": 1341,
	"./section-backgrounds/section-bg-28-small.webp": 1342,
	"./section-backgrounds/section-bg-28.webp": 1343,
	"./section-backgrounds/section-bg-29-small.webp": 1344,
	"./section-backgrounds/section-bg-29.webp": 1345,
	"./section-backgrounds/section-bg-3-small.webp": 1346,
	"./section-backgrounds/section-bg-3.webp": 1347,
	"./section-backgrounds/section-bg-30-small.webp": 1348,
	"./section-backgrounds/section-bg-30.webp": 1349,
	"./section-backgrounds/section-bg-31-small.webp": 1350,
	"./section-backgrounds/section-bg-31.webp": 1351,
	"./section-backgrounds/section-bg-32-small.webp": 1352,
	"./section-backgrounds/section-bg-32.webp": 1353,
	"./section-backgrounds/section-bg-33-small.webp": 1354,
	"./section-backgrounds/section-bg-33.webp": 1355,
	"./section-backgrounds/section-bg-34-small.webp": 1356,
	"./section-backgrounds/section-bg-34.webp": 1357,
	"./section-backgrounds/section-bg-35-small.webp": 1358,
	"./section-backgrounds/section-bg-35.webp": 1359,
	"./section-backgrounds/section-bg-36-small.webp": 1360,
	"./section-backgrounds/section-bg-36.webp": 1361,
	"./section-backgrounds/section-bg-37-small.webp": 1362,
	"./section-backgrounds/section-bg-37.webp": 1363,
	"./section-backgrounds/section-bg-38-small.webp": 1364,
	"./section-backgrounds/section-bg-38.webp": 1365,
	"./section-backgrounds/section-bg-39-small.webp": 1366,
	"./section-backgrounds/section-bg-39.webp": 1367,
	"./section-backgrounds/section-bg-4-small.webp": 1368,
	"./section-backgrounds/section-bg-4.webp": 1369,
	"./section-backgrounds/section-bg-40-small.webp": 1370,
	"./section-backgrounds/section-bg-40.webp": 1371,
	"./section-backgrounds/section-bg-41-small.webp": 1372,
	"./section-backgrounds/section-bg-41.webp": 1373,
	"./section-backgrounds/section-bg-42-small.webp": 1374,
	"./section-backgrounds/section-bg-42.webp": 1375,
	"./section-backgrounds/section-bg-43-small.webp": 1376,
	"./section-backgrounds/section-bg-43.webp": 1377,
	"./section-backgrounds/section-bg-44-small.webp": 1378,
	"./section-backgrounds/section-bg-44.webp": 1379,
	"./section-backgrounds/section-bg-45-small.webp": 1380,
	"./section-backgrounds/section-bg-45.webp": 1381,
	"./section-backgrounds/section-bg-46-small.webp": 1382,
	"./section-backgrounds/section-bg-46.webp": 1383,
	"./section-backgrounds/section-bg-47-small.webp": 1384,
	"./section-backgrounds/section-bg-47.webp": 1385,
	"./section-backgrounds/section-bg-48-small.webp": 1386,
	"./section-backgrounds/section-bg-48.webp": 1387,
	"./section-backgrounds/section-bg-49-small.webp": 1388,
	"./section-backgrounds/section-bg-49.webp": 1389,
	"./section-backgrounds/section-bg-5-small.webp": 1390,
	"./section-backgrounds/section-bg-5.webp": 1391,
	"./section-backgrounds/section-bg-50-small.webp": 1392,
	"./section-backgrounds/section-bg-50.webp": 1393,
	"./section-backgrounds/section-bg-51-small.webp": 1394,
	"./section-backgrounds/section-bg-51.webp": 1395,
	"./section-backgrounds/section-bg-52-small.webp": 1396,
	"./section-backgrounds/section-bg-52.webp": 1397,
	"./section-backgrounds/section-bg-53-small.webp": 1398,
	"./section-backgrounds/section-bg-53.webp": 1399,
	"./section-backgrounds/section-bg-54-small.webp": 1400,
	"./section-backgrounds/section-bg-54.webp": 1401,
	"./section-backgrounds/section-bg-55-small.webp": 1402,
	"./section-backgrounds/section-bg-55.webp": 1403,
	"./section-backgrounds/section-bg-56-small.webp": 1404,
	"./section-backgrounds/section-bg-56.webp": 1405,
	"./section-backgrounds/section-bg-57-small.webp": 1406,
	"./section-backgrounds/section-bg-57.webp": 1407,
	"./section-backgrounds/section-bg-58-small.webp": 1408,
	"./section-backgrounds/section-bg-58.webp": 1409,
	"./section-backgrounds/section-bg-59-small.webp": 1410,
	"./section-backgrounds/section-bg-59.webp": 1411,
	"./section-backgrounds/section-bg-6-small.webp": 1412,
	"./section-backgrounds/section-bg-6.webp": 1413,
	"./section-backgrounds/section-bg-60-small.webp": 1414,
	"./section-backgrounds/section-bg-60.webp": 1415,
	"./section-backgrounds/section-bg-61-small.webp": 1416,
	"./section-backgrounds/section-bg-61.webp": 1417,
	"./section-backgrounds/section-bg-7-small.webp": 1418,
	"./section-backgrounds/section-bg-7.webp": 1419,
	"./section-backgrounds/section-bg-8-small.webp": 1420,
	"./section-backgrounds/section-bg-8.webp": 1421,
	"./section-backgrounds/section-bg-9-small.webp": 1422,
	"./section-backgrounds/section-bg-9.webp": 1423,
	"./simple-lms-banner-bg-fa.jpg": 1947,
	"./simple-lms-banner-bg.jpg": 1948,
	"./site-ad-banner-desktop.webp": 1949,
	"./site-ad-banner-laptop.webp": 1950,
	"./site-ad-banner-mobile-fa.webp": 1951,
	"./site-ad-banner-mobile.webp": 1952,
	"./sticky-banner-bg-mobile.png": 1953,
	"./sticky-banner-bg.png": 1954,
	"./thank-you-bg-business.jpg": 1955,
	"./thank-you-bg.jpg": 1956,
	"./ty-downloadable-1.png": 1957,
	"./ty-downloadable-auth-user-mobile.jpg": 1958,
	"./ty-downloadable-auth-user.jpg": 1959,
	"./ty-downloadable-mobile.png": 1960,
	"./ty-downloadable.png": 1961,
	"./uncheck.png": 1962,
	"./verify-certificate-mobile.jpg": 1963,
	"./verify-certificate.jpg": 1964
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1798;